/**
 * Standardized design tokens for Dialog, Drawer, and Sheet components.
 * Use these constants to ensure consistent styling across all overlay components.
 */
export const DIALOG_TOKENS = {
  // Header
  headerPadding: "px-4 py-3",
  headerBorder: "border-b",
  titleSize: "text-base font-semibold",
  titleGap: "gap-2",

  // Content
  contentPadding: "px-4 py-4",
  contentScrollable: "overflow-y-auto flex-1 min-h-0",

  // Footer
  footerPadding: "p-4 pt-3 border-t",
  footerGap: "gap-2",
  cancelButtonVariant: "ghost" as const,
  submitButtonVariant: "default" as const,
  buttonHeight: "h-10",
  buttonLayout: "flex-1",

  // DialogContent
  dialogMaxWidth: "max-w-md",
  dialogMaxHeight: "max-h-[85vh]",
  dialogPadding: "p-0",
} as const;

/**
 * CSS classes for header with icon
 */
export const headerWithIconClass = "flex items-center gap-2";

/**
 * CSS classes for standard form footer with two buttons
 */
export const formFooterClass = "flex gap-2 p-4 pt-3 border-t";

/**
 * CSS classes for full-width form buttons
 */
export const formButtonClass = "flex-1 h-10";
